import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import './styles/animations.css';
import './styles/softDesign.css';
import HomePage from './pages/HomePage';
import PlannerPage from './pages/PlannerPage';
import HealthPage from './pages/HealthPage';
import SelfDevelopmentPage from './pages/SelfDevelopmentPage';
import WellnessPage from './pages/WellnessPage';
import CommunityPage from './pages/CommunityPage';
import Navigation from './components/Navigation';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Navigation />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/planner" element={<PlannerPage />} />
              <Route path="/health" element={<HealthPage />} />
              <Route path="/self-development" element={<SelfDevelopmentPage />} />
              <Route path="/wellness" element={<WellnessPage />} />
              <Route path="/community" element={<CommunityPage />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;